import React, { useState } from "react";
import toast from "react-hot-toast";
import { useQuery } from "react-query";
import Spinner from "../../../Component/Spinner/Spinner";
import useScrollToTop from "../../../hooks/useScrollToTop";
import useTitle from "../../../hooks/useTitle";
import ConfirmationModal from "../../Shared/ConfirmationModal/ConfirmationModal";
import ErrorMessage from "../../Shared/ErrorMessage/ErrorMessage";

const ReportedItem = () => {
  const [deletingReport, setDeletingReport] = useState(null);
    const [errorMessages, setErrorMessages] = useState("");

    useScrollToTop();
    useTitle("Reported Products");

  const closeModal = () => {
    setDeletingReport(null);
  };

  const {
    data: report = [],
    refetch,
    isLoading,
  } = useQuery({
    queryKey: ["report"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/products/reported`,
        {
          method: "GET",
          headers: {
            authorization: `bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = res.json();
        if (data.success) {
            setErrorMessages("");
            return data.data;
        } else {
            setErrorMessages(data.error);
            return [];
        }
    },
  });

  const handleDeleteProduct = (product) => {
    fetch(`${process.env.REACT_APP_API_URL}/products/reported/${product._id}`, {
      method: "DELETE",
      headers: {
        authorization: `bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.deletedCount > 0) {
          refetch();
          toast.success(`${product.title} ${data.message}`);
        } else {
          toast.error(`${product.title} ${data.error}`);
        }
      });
  };

  if (isLoading) {
    return <Spinner />;
  }

    if (errorMessages) {
        return <ErrorMessage error={errorMessages} />;
    }

  return (
    <div className="mx-10">
      <h1 className="text-2xl">Reported Items</h1>
      <div className="overflow-x-auto w-full">
        <table className="w-full whitespace-no-wrap">
          {/* <!-- head --> */}
          <thead>
            <tr className="text-xs font-semibold tracking-wide text-left text-gray-700 uppercase border-b dark:border-gray-700 bg-gray-300 dark:text-gray-400 dark:bg-black">
              <th className="px-4 py-3">Image</th>
              <th className="px-4 py-3">Product Name</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {report?.map((r) => (
              <tr key={r._id}>
                <td className="px-4 py-3">
                  <div className="flex items-center space-x-3">
                    <div className="avatar">
                      <div className="mask mask-squircle w-12 h-12">
                        <img src={r.img} alt={r.title} />
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <div>
                    <div className="font-bold">{r.title}</div>
                  </div>
                </td>
                <td className="px-4 py-3">{r.seller_email}</td>
                <th>
                  <label
                    onClick={() => setDeletingReport(r)}
                    htmlFor="confirmation-modal"
                    className="btn btn-error btn-xs">
                    Delete
                  </label>
                </th>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {deletingReport && (
        <ConfirmationModal
          title={`Are you sure you want to delete?`}
          message={`If you delete ${deletingReport.title}. It cannot be undone.`}
          successAction={handleDeleteProduct}
          successButtonName="Delete"
          modalData={deletingReport}
          closeModal={closeModal}></ConfirmationModal>
      )}
    </div>
  );
};

export default ReportedItem;
